import { View } from 'foundations-components/components/View';
import enviro from 'enviro';
import { useMemo } from 'react';
import { VideoPlayerWithControls } from '../../features/video';
import LessonInfoTabs from './LessonInfoTabs';
import { LearningContentContainer } from '../../features/learningContent';
import LearningPageMainSection from '../../containers/TrackPage/LearningPageMainSection';
import { VideoContentWithInteractiveEducation } from '../../features/interactiveEducation/components/VideoContentWithInteractiveEducation';
import { extractVideoMetadata, buildInteractiveContentTrackingProps } from '../../features/interactiveEducation/utils/contentUtils';
import { usePageTitle } from '../../hooks/usePageTitle';
import { isInternalPortal } from '../../features/accounts/components/ExternalPortalOnly';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const LessonContentWithInteractiveEducation = ({
  lessonContentId,
  lesson,
  onAdvanceContent,
  onResourceClick,
  videoContent
}) => {
  usePageTitle({
    i18nKey: 'learningCenter.dynamicPageTitles.lessonContent',
    options: {
      contentName: videoContent === null || videoContent === void 0 ? void 0 : videoContent.name
    },
    skip: !(videoContent !== null && videoContent !== void 0 && videoContent.name)
  });
  const lessonId = Number(lesson.id);
  const language = lesson.language || 'en';
  const {
    contentPortalId,
    professorId,
    videoId
  } = extractVideoMetadata(videoContent);

  // Combine lesson and videoContent data for tracking props
  const trackingPropsSource = useMemo(() => videoContent ? Object.assign({}, videoContent, {
    hsSoftwareFilters: lesson.hsSoftwareFilters,
    subCategories: lesson.subCategories,
    useCases: lesson.useCases
  }) : undefined, [videoContent, lesson]);
  const interactiveContentTrackingProps = useMemo(() => buildInteractiveContentTrackingProps(trackingPropsSource, 'LESSON', lessonContentId || lessonId, professorId), [trackingPropsSource, lessonContentId, lessonId, professorId]);
  return /*#__PURE__*/_jsxs(LearningContentContainer, {
    contentId: lessonContentId,
    language: language,
    lessonId: lessonId,
    children: [/*#__PURE__*/_jsx(LearningPageMainSection, {
      children: /*#__PURE__*/_jsx(View, {
        "data-contentid": lessonContentId,
        "data-test-id": "stored-content-container",
        children: /*#__PURE__*/_jsx(VideoContentWithInteractiveEducation, {
          contentPortalId: contentPortalId,
          contentType: "LESSON",
          creatorRegion: videoContent.hublet,
          interactiveContentTrackingProps: interactiveContentTrackingProps,
          language: language,
          lessonContentId: lessonContentId,
          primaryContentId: lessonId,
          videoId: videoId,
          videoTitle: videoContent.name,
          children: ({
            displayInteractiveEducation,
            handleDisplayInteractiveEducation,
            interactiveEducationEnabled
          }) => /*#__PURE__*/_jsx(VideoPlayerWithControls, {
            additionalTracking: interactiveContentTrackingProps,
            contentId: String(lessonContentId),
            displayInteractiveEducation: displayInteractiveEducation,
            enableAdaptToIndustry: enviro.isQa() || isInternalPortal(),
            enableQuizMe: true,
            enableSummarize: true,
            handleDisplayInteractiveEducation: handleDisplayInteractiveEducation,
            interactiveEducationEnabled: interactiveEducationEnabled,
            isPubliclyVisible: lesson.visibility === 'PUBLIC',
            language: language,
            lessonId: String(lessonId),
            lessonName: lesson.name,
            onFinish: onAdvanceContent
          })
        })
      })
    }), /*#__PURE__*/_jsx(LessonInfoTabs, {
      contentId: String(lessonContentId),
      fullLesson: lesson,
      onResourceClick: onResourceClick
    })]
  });
};
export default LessonContentWithInteractiveEducation;